import { Form, Input, Select } from "antd";
import { FormInstance } from "antd/lib";
import { observer } from "mobx-react-lite";
import * as React from "react";
import {
  ZSpecCategoryOption,
  ZSpecificationCard,
} from "src/business/specification";
import { specCategoryOptions } from "src/business/specification/specCategoryOptions";
import { maxNameLength, rxName, rxNameMsg } from "src/common/rxName";
import { IdBox } from "src/components/IdBox";

import { SpecEditorVerSwitch } from "../../SpecEditorVerSwitch";
import { ManagementSpecCommonCardStore } from "../ManagementSpecCommonCardStore";
import { AttrListV2 } from "./AttrListV2";
import * as styles from "./SpecEditorFormV2.module.less";

const field = (key: keyof ZSpecificationCard): string => key;

type PropsSpecEditorFormV2 = {
  store: ManagementSpecCommonCardStore;
  form: FormInstance;
  onFinish: (values: unknown) => void;
};

export const SpecEditorFormV2: React.FC<PropsSpecEditorFormV2> = observer(
  (props) => {
    const { store, form, onFinish } = props;
    const { initialData } = store;
    const srcData =
      store.data.status === "ready" ? store.data.result : undefined;
    React.useEffect(() => {
      form.resetFields();
      form.setFieldsValue(initialData);
    }, [JSON.stringify(initialData)]);
    return (
      <Form<ZSpecificationCard>
        form={form}
        layout="vertical"
        className={styles.frame}
        onFinish={onFinish}
        onFinishFailed={() => store.setActiveTab("general")}
        initialValues={initialData}
        onValuesChange={(_, values) => {
          store.onChange(values);
        }}
      >
        <div className={styles.fieldsBox}>
          <SpecEditorVerSwitch store={store} />
          <div className={styles.fieldsLimited}>
            <Form.Item
              name={field("name")}
              label="Системное название"
              rules={[
                { required: true },
                { pattern: rxName, message: rxNameMsg() },
                { max: maxNameLength },
              ]}
              tooltip="Системные названия любых спецификаций не должны совпадать"
            >
              <Input
                allowClear
                disabled={!store.isNew}
                maxLength={maxNameLength}
              />
            </Form.Item>
            <IdBox entity={srcData} />
            <Form.Item
              name={field("displayName")}
              label="Название"
              rules={[{ max: maxNameLength }]}
              tooltip="Названия любых спецификаций не должны совпадать"
            >
              <Input allowClear maxLength={maxNameLength} />
            </Form.Item>
            <Form.Item name={field("description")} label="Описание">
              <Input.TextArea allowClear />
            </Form.Item>
            <Form.Item
              name={field("categoryDataCode")}
              label="Категория данных"
            >
              <Select<Number, ZSpecCategoryOption>
                fieldNames={{
                  value: "code",
                }}
                options={specCategoryOptions}
              />
            </Form.Item>
          </div>
          <Form.Item name={["definition", "attributes"]}>
            <AttrListV2
              availableAttrTypes={store.attrFeatures?.availableAttrTypes}
            />
          </Form.Item>
        </div>
      </Form>
    );
  },
);
